<script>
import {
  Line,
  mixins
} from 'vue-chartjs'
const {
  reactiveProp
} = mixins
export default {
  name: 'LineChart',
  extends: Line,
  mixins: [reactiveProp],
  /*components: {
    Line
  },*/
  props: {
    options: {
      type: Object,
      default: function() {
        return {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              display: true,
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
              }
            }]
          },
        }
      }
    }
  },
  watch: {
    chartData: function(a, b) {
      console.log("chartData cambiado", a, b)

      this.renderChart(this.chartData, this.$options)
    }
  },
  mounted() {
    console.log("Dibujando LineChart", this.chartData, reactiveProp, Line)
    this.renderChart(this.chartData, this.options)
  }
}
</script>
